export default __webpack_public_path__ + "static/slide-1-36ecb7c98f69b9f764f427146c1df17b.jpg";